import CreateAppSystemWebApiRequestModelBase from '../_generated/modelBases/create-app-system-web-api-request-model-base';

export default class CreateAppSystemWebApiRequestModel extends CreateAppSystemWebApiRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
